import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "participant-item" }
const _hoisted_2 = { class: "participant-item__thumbnail" }
const _hoisted_3 = { class: "participant-item__name heading-s" }
const _hoisted_4 = {
  key: 0,
  class: "participant-item__role"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_WatchListsGroup = _resolveComponent("WatchListsGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NThumbnail, {
        modelValue: _ctx.item.thumbnail,
        onAction: _cache[0] || (_cache[0] = (v) => _ctx.$emit('action', v))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item.name), 1),
    (_ctx.item.matched_lists)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_WatchListsGroup, {
            items: _ctx.item.matched_lists
          }, null, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ]))
}